export enum DATE_FORMATS {
  TRANSACTION_DATES = 'DD/MM/YYYY',
  SERVICE_PERIOD = 'DD/MM/YYYY',
  SUBSCRIPTION_END_DATE = 'YYYY-MM-DD hh:mm A',
  DATE_AND_TIME = 'DD/MM/YYYY hh:mm a',
  DOCUMENTS_DATE = 'DD/MM/YYYY',
}
